/*************************************************/
/* INVIEW                                        */
/*************************************************/
import inView from "../vendor/in-view.min.js";

// Init inview navigation
export function inview () {
    let $inViewElem,
        inViewActiveClass;

    const init = function () {
        $inViewElem = ".banner",
        inViewActiveClass = "in-view";

        // inView animations
        inView.offset(-350);
        inView($inViewElem).on("enter", function (t) {
            return t.classList.add(inViewActiveClass);
        }).on("exit", function (t) {
            //return t.classList.remove(inViewActiveClass);
        });
    };
    init();
};